import { IAvatarSize } from "src/components-mui/base/avatar/avatar.constants";
import { TraderAvatar } from "src/components-mui/common/trader-avatar/trader-avatar";
import { mapAutoCompleteTraderToAvatarUser } from "src/components-mui/common/trader-avatar/trader-avatar.mappers";
import { IAutoCompleteTrader } from "src/types/common";

interface ISearchItemTraderAvatarProps {
    trader: IAutoCompleteTrader;
    size?: IAvatarSize;
}

export const SearchItemTraderAvatar = ({ trader, size = "xs" }: ISearchItemTraderAvatarProps) => (
    <TraderAvatar size={size} trader={mapAutoCompleteTraderToAvatarUser(trader)} loading="eager" sx={{ flexShrink: 0, mr: 1 }} />
);
